<template>
  <a-card :bordered="option.border" :bodyStyle="bodyStyle">
    <slot name="cardBody"></slot>
  </a-card>
</template>

<script>
export default {
  name: 'BaseCard',
  props: ['option'],
  computed: {

  },
  data () {
    return {
      bodyStyle: {
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
